import { Link } from 'react-router-dom';

export interface ScopeHeaderProps {
  scopeLabel: string;
}

export const ScopeHeader = ({ scopeLabel }: ScopeHeaderProps) => {
  return (
    <div>
      <h1 className="font-serif text-3xl text-gray-900 mb-1">Wines {scopeLabel}</h1>
      <Link to="/wineries" className="text-sm text-primary-700 hover:text-primary-800">
        Change region →
      </Link>
    </div>
  );
};
